
import { FaArrowCircleUp, FaUserPlus } from "react-icons/fa";
import {BoxStats} from '../BoxStats'
import {BoxWrapper} from '../BoxWrapper'
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { FilteredDashboardStats } from '../../types/dashboard.types';

type DashbardTrackingStatsProps = {
  compareStats?: FilteredDashboardStats | null;
  compareLabel?: string;
};

export default function DashbardTrackingStats({ compareStats = null, compareLabel = 'Compare' }: DashbardTrackingStatsProps) {

  const { filteredStats } = useSelector((state:RootState) => state.dashboard);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full">
        {/* <BoxWrapper
             style={"bg-slate-100 border-gray-50"}>
            <BoxStats 
              title={"Inventory"}
              stats={"0"}
              styles="bg-slate-200"
              icon={<FaHandHoldingHeart className="text-3xl text-slate-600"/>}
             
            />
        </BoxWrapper> */}
    		<BoxWrapper className={"bg-gradient-to-br from-sky-50/80 via-white/70 to-blue-100/80 dark:from-sky-900/30 dark:via-slate-900/80 dark:to-blue-900/25 border-sky-200/60 dark:border-sky-400/25"}>
            <BoxStats 
              title={"Orders waiting fulfillment"}
                stats={filteredStats.ordersWaitingFullfillment}
                compareStats={compareStats?.ordersWaitingFullfillment ?? null}
                compareLabel={compareLabel}
                  styles="bg-sky-100/80 dark:bg-sky-400/20"
              icon={<FaUserPlus className="text-xl text-primary-100"/>}
            />
        </BoxWrapper>
    		<BoxWrapper className={"bg-gradient-to-br from-indigo-50/80 via-white/70 to-violet-100/80 dark:from-indigo-900/30 dark:via-slate-900/80 dark:to-violet-900/25 border-indigo-200/60 dark:border-indigo-400/25"}>
            <BoxStats 
              title={"Fulfilled waiting assignment"}
                stats={filteredStats.fulfilledWaitingAssignment}
                compareStats={compareStats?.fulfilledWaitingAssignment ?? null}
                compareLabel={compareLabel}
                  styles="bg-indigo-100/80 dark:bg-indigo-400/20"
              icon={<FaArrowCircleUp className="text-xl text-primary-100"/>}
            />
        </BoxWrapper>
		</div>
  )
}
